var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8397 0.333374C20.4933 0.333374 21.8332 1.60629 21.8332 3.17712V13.7396C21.8332 15.3105 20.4933 16.5834 18.8397 16.5834H3.15992C2.36602 16.5834 1.60463 16.2838 1.04326 15.7505C0.481881 15.2172 0.166504 14.4938 0.166504 13.7396V3.17712C0.166504 1.60629 1.50642 0.333374 3.15992 0.333374H18.8397ZM20.4077 5.3985L11.3431 10.1348C11.2498 10.1835 11.1463 10.2118 11.04 10.2175C10.9337 10.2232 10.8275 10.2063 10.729 10.1679L10.6566 10.1354L1.59194 5.39796V13.7396C1.59194 14.1347 1.75714 14.5136 2.05119 14.7929C2.34525 15.0723 2.74407 15.2292 3.15992 15.2292H18.8397C19.2556 15.2292 19.6544 15.0723 19.9485 14.7929C20.2425 14.5136 20.4077 14.1347 20.4077 13.7396V5.3985ZM18.8397 1.68754H3.15992C2.74407 1.68754 2.34525 1.84448 2.05119 2.12383C1.75714 2.40318 1.59194 2.78206 1.59194 3.17712V3.85367L10.9998 8.76875L20.4077 3.85312V3.17712C20.4077 2.78206 20.2425 2.40318 19.9485 2.12383C19.6544 1.84448 19.2556 1.68754 18.8397 1.68754Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBox);
export default __webpack_public_path__ + "static/media/emailBox.eb006d5b3f4c1e7be69b4731e0190741.svg";
export { ForwardRef as ReactComponent };